import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const userReferralPlanMenuRegistry = {
    core_userReferralPlan: {
        label: "User Referral Plan",
        link: PAGE_URL.USER_REFERRAL_PLAN_PAGE,
        key: PAGE_URL.USER_REFERRAL_PLAN_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default userReferralPlanMenuRegistry;
